import { cn } from "@pcln/horizon";
import { SEARCH_FORM_TABS_SLOT_CLASS_NAMES } from "./SearchFormTabs.constants.js";
function getSearchFormTabsSlotClassNames(overrides = {}) {
    return Object.fromEntries(Object.entries(SEARCH_FORM_TABS_SLOT_CLASS_NAMES).map(([key, defaultVal])=>[
            key,
            cn(defaultVal, overrides[key])
        ]));
}
export { getSearchFormTabsSlotClassNames };
